import { Vector3 } from "three";
import { IMeasurement, IPanelDraggable } from "./types";

/**
 * Restore the saved Measurement Result panel position onto a freshly-created
 * measurement (SC_QUICK-2187, QU3DW-1367). Used by
 * MeasurementManager.createInitialMeasurement when loading measurements from
 * server data. Applies to all 7 measurement types — each one implements
 * IPanelDraggable, detected via duck-typing (same pattern as
 * PanelDragObservable.hitPanel).
 *
 * No-op when `data.panelPosition` is absent (legacy data, EC-1) or when the
 * measurement does not implement IPanelDraggable.
 */
export function restorePanelPositionIfPresent(
  measurement: IPanelDraggable,
  data: IMeasurement
): void {
  if (!data.panelPosition) return;
  if (typeof measurement?.setPanelPosition !== "function") return;

  measurement.setPanelPosition(
    new Vector3(data.panelPosition.x, data.panelPosition.y, data.panelPosition.z)
  );
}
